<template>
  <v-menu
    :close-on-content-click="false"
    v-model="menuOpened"
    max-width="350"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <v-btn x-small
             v-on="on"
             :disabled="disabled || loading"
             @click.stop.prevent="">
        {{listLength}} transportadoras(es) recusada(s)
      </v-btn>
    </template>
    <v-card>
      <v-row class="text--primary px-3">
        <v-list>
          <template v-for="(resposta, index) in transportadoras">
            <v-list-item
              :key="resposta.id">
              <v-list-item-content>
                <v-list-item-title>{{ resposta.transportadora.pessoa.nome }}</v-list-item-title>
                <v-list-item-subtitle>
                  <span v-if="!resposta.outroMotivo">{{ situacao(resposta)  }}</span>
                  <v-tooltip top v-if="resposta.outroMotivo">
                    <template v-slot:activator="{ on }">
                        <span v-on="on">
                         {{ situacao(resposta) }}
                        </span>
                    </template>
                    <span>{{resposta.outroMotivo}}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider v-if="showDivider(index)" :key="`div-${resposta.id}`"></v-divider>
          </template>
        </v-list>
      </v-row>
    </v-card>
  </v-menu>
</template>

<script>
import { SituacaoSolicitacaoFrete } from 'px-business-components';
import RespostaFreteService from '../resposta-frete-service';

export default {
  props: {
    cotacaoId: [String, Number],
    searchMethod: {
      type: Function,
      default: RespostaFreteService.getRecusadas,
    },
  },
  data() {
    return {
      loading: true,
      menuOpened: false,
      transportadoras: [],
    };
  },
  computed: {
    disabled() {
      return !this.transportadoras || this.transportadoras.length <= 0;
    },
    listLength() {
      if (this.transportadoras) {
        return this.transportadoras.length;
      }
      return 0;
    },
    showDivider() {
      return index => index !== (this.transportadoras.length - 1);
    },
    situacao() {
      return item => SituacaoSolicitacaoFrete.keys[item.situacao].description;
    },
  },
  methods: {
    getSemEstoque() {
      this.loading = true;
      this.searchMethod(this.cotacaoId)
        .then(({ data }) => {
          this.transportadoras = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getSemEstoque();
  },
};
</script>
